var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"infiniteScrollWrap",on:{"scroll":_vm.onScroll}},[_vm._t("default"),_vm._t("loading",function(){return [_c('span',[_vm._v("Loading...")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }